
import { useEffect } from 'react';
import { setupCacheEventListeners, permissionEventBus } from '@/services/permissions';

/**
 * Hook for managing permissions event listeners
 */
export const usePermissionsEvents = (
  authReady: boolean,
  userId: string | undefined,
  refreshPermissions: () => Promise<void>,
  eventListenerCleanupRef: React.MutableRefObject<(() => void) | null>
) => {
  useEffect(() => {
    if (!authReady || !userId) return;


    
    // Setup cache event listeners
    const cacheCleanup = setupCacheEventListeners();
    
    // Setup user-specific permission event listener
    const permissionCleanup = permissionEventBus.onAny((event) => {
      // Only handle events for current user
      if (event.userId === userId) {
        // Force refresh permissions after a small delay to allow backend to process
        setTimeout(() => {
          refreshPermissions();
        }, 1000);
      }
    });
    
    eventListenerCleanupRef.current = () => {
      cacheCleanup();
      permissionCleanup();
    };
    
    return () => {
      if (eventListenerCleanupRef.current) {
        eventListenerCleanupRef.current();
        eventListenerCleanupRef.current = null;
      }
    };
  }, [authReady, userId, refreshPermissions, eventListenerCleanupRef]);
};
